export const AUTH_CONSTANTS = {
    APPLY_CREATE_NEW_ACCOUNT: 'APPLY FOR A NEW CREATOR ACCOUNT',
    STEP_1_4: 'Step 1 of 4',
    PERSONAL_INFORMATION: 'PERSONAL INFORMATION',
    SELECT_INTERESTS: 'What are your Interests? (Select as many as you like):',
    CONTENT_TYPE_REQUIRED: '* Content type is required',
    HAVE_ACCOUNT: 'Already have an account?',
    GO_TO_PREFERENCE: 'go to Preferences > Create on TopFan',
    SIGN_IN: 'Sign in',
    CREATING_ACCOUNT: 'By creating an account, you agree to our',
    CONTINUE: 'Continue',
    SUCCESS: 'success',
    STEP_2_4: 'Step 2 of 4',
    STEP_3_4: 'Step 3 of 4',
    STEP_4_4: 'Step 4 of 4',
    STEP_2_3: 'Step 2 of 3',
    CONTINUE_UPPER: 'CONTINUE',
    CONTENT_CREATOR_SETUP: 'Content Creator Setup',
    CONFIRM_CREATOR_SELECTION: 'Confirm Your Creator Type Selection',
    RESEND_CODE: 'Resend Code',
    VERIFY: 'Verify',
    VERIFY_YOUR_IDENTITY: 'VERIFY YOUR IDENTITY',
    CHOOSE_YOUR_CREATOR_TYPE: 'CHOOSE YOUR CREATOR TYPE',
    ACCOUNT_INFORMATION: 'ACCOUNT INFORMATION',
    CREATOR_INFORMATION: 'Profile Avatar* & Banner Image*',
    CLICK_HERE: 'Click Here',
    IF_YOU_ARE_A_FAN: 'If you are a Fan, ',
    ARE_YOU_A_CREATOR: 'Are you a Creator? ',
    GET_STARTED: 'Get Started',
    SIGN_UP: 'SIGN UP',
    SIGN_IN_CAPS: 'SIGN IN',
    CREATE_NEW_FAN_ACCOUNT: 'CREATE NEW FAN ACCOUNT',
    BACK: 'Back',
    STEP_1_3: 'Step 1 of 3',
    STEP_3_3: 'Step 3 of 3',
    STEP_1_2: 'Step 1 of 2',
    STEP_2_2: 'Step 2 of 2',
    CREATOR_FLOW: 'creator_flow',
    CREATOR_SIGNUP_NOTE: 'Note: Enter your Legal Name on this Step, you will add your Publicly Displayed Name on Step 2.',
    CREATOR_SIGNUP_HINT: 'If you are an organization, band, team, etc. please register as the legal representative at this step. On Step 2, you can enter the Publicly Displayed Name of the organization that fans will view you as.',
    PROFILE_AVATAR_BANNER_IMAGE: 'Profile Avatar* & Banner Image',
    SET_COMMUNITY_AVATAR_PROFILE_IMAGE: 'Set your Community Avatar* and Profile Image',
    EXPLORE_FEATURES: 'Explore Features',
    EXPLORE_COMPARISON: 'Compare',
    Features: 'Features',
    COMPARE: 'Compare',
    COMMUNITY_VERTICALS: 'Community Verticals',
    PLATFORM: 'Platform'
}

export const PRO_HEADER_NAV = {
    VERTICALS: [
        { label: 'Music & Entertainment', route: '/apps/music-band-fan-club/' },
        { label: 'Film & Television', route: '/apps/mobile-apps-film-television/' },
        { label: 'Sports Team Fan Club', route: '/apps/sports-teams-nil-collectives-membership' },
        { label: 'Associations & Interest Topics', route: '/apps/associations-community-platform/' },
        { label: 'Conferences & Festivals', route: '/apps/virtual-conferences/' },
        { label: 'Facebook Groups', route: '/apps/facebook-group-alternative/' },
        { label: 'Patreon Creators', route: '/apps/content-creators-patreon-alternative/' },
        { label: 'View All Communities', route: '/apps' }
    ],
    PLATFORMS: [
        { label: 'Fan Relationship Management', route: '/fan-relationship-management/' },
        { label: 'Direct to Fan', route: '/direct-to-fan' },
        { label: 'Challenge Marketing', route: '/challenge-marketing' },
        { label: 'Fan Engagement', route: '/fan-interactivity' },
        { label: 'Mobile Web', route: '/mobile-web' }
    ]
} as const;

export const TARGET_ORIGIN = 're-captcha';
export const RECAPTCHA_POST_MESSAGE = {
    BUBBLE_OPENED: 'bubble-opened',
    BUBBLE_CLOSED: 'bubble-closed',
    CAPTCHA_COMPLETED: 'captcha-completed'
}